const KEY = "happyschool_active_school_id";

export function getActiveSchoolId() {
  return localStorage.getItem(KEY) || null;
}

export function setActiveSchoolId(schoolId) {
  if (schoolId) localStorage.setItem(KEY, schoolId);
  else localStorage.removeItem(KEY);
}
